import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { FileDeleteRequestBody, FileDeleteResponse } from "./types";

export class FileDeleteAPI extends BaseAPI<
  FileDeleteRequestBody,
  FileDeleteResponse
> {
  protected route = ApiRoutes.file.delete;
  protected method = RequestMethod.POST;
}
